export enum ChatSubject {
  Chat = '"PBB_Hyp_Acquisitie_CH"',
  Call = '"anna_iv_mha"',
  Revision = '"anna_hyp_woonwensgesprek"'
}

export enum CallSubject {
  Default = '"anna_iv_mha"',
  Revision = '"anna_hyp_woonwensgesprek"'
}
